import './index.scss';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Grid } from '@material-ui/core';
import { Sidebar } from './Sidebar';

const gridClassNames = { root: 'admin-page__grid' };

export const DashboardPage = () => {
  return (
    <Grid container classes={gridClassNames}>
      <Grid item xs={6} sm={2}>
        <Box className="management-backdrop">
          <Sidebar />
        </Box>
      </Grid>
      <Grid item xs={6} sm={10}>
        <Container>
          <Outlet />
        </Container>
      </Grid>
    </Grid>
  );
};
